module.exports = __webpack_public_path__ + "static/media/25181520_1545557758827193_1533142754_n_edited.db4028fd.jpg";